import constants from './constants';

/* GET LARGEST PRIORITY:
 * Helper function to find the largest priority value (lowest priority)...
 * ...among the filterConfigs passed in.
 */
const getLargestPriority = (filterConfigs) => {
  // Create a store to hold the highest priority value;
  var largestPriority = 0;
  // Iterate through the filter configs
  for (var key in filterConfigs) {
    if (Object.prototype.hasOwnProperty.call(filterConfigs, key)) {
      // if we find a higher value, increment the store
      largestPriority =
        filterConfigs[key].sortState.priority > largestPriority
          ? filterConfigs[key].sortState.priority
          : largestPriority;
    }
  }
  // return the store.
  return largestPriority;
};

/* LOWER LARGER PRIORITY BY 1:
 * Helper function to lower all priorities larger than priorityLost by one.
 */
const lowerLargerPrioritiesByOne = (filterConfigs, priorityLost) => {
  var tempConfigs = {};
  for (var key in filterConfigs) {
    if (Object.prototype.hasOwnProperty.call(filterConfigs, key)) {
      const { sortState, ...rest } = filterConfigs[key];
      tempConfigs[key] = {
        sortState: {
          direction: sortState.direction,
          priority:
            sortState.priority > priorityLost
              ? sortState.priority - 1
              : sortState.priority,
        },
        ...rest,
      };
    }
  }
  return tempConfigs;
};

/* REPLACE CONFIG BY DATA INDEX:
 * Create a copy of the filterConfigs object...
 * ...replacing the object with the key dataIndex...
 * ...with newConfig.
 */
const replaceConfigByDataIndex = (filterConfigs, dataIndex, newConfig) => {
  const tempConfigs = {};

  for (var key in filterConfigs) {
    if (Object.prototype.hasOwnProperty.call(filterConfigs, key)) {
      tempConfigs[key] = filterConfigs[key];
    }
  }
  tempConfigs[dataIndex] = newConfig;

  return tempConfigs;
};

/* UPDATE PRIORITIES:
 * A helper function that updates the priorities of all configs...
 * ...based on the changes found within the config with the given dataIndex.
 */
const updatePriorities = (filterConfigs, dataIndex) => {
  // create a temporary store for the input filterConfigs so we can modify it for output.
  var tempConfigs = filterConfigs;

  // If the sort direction for this action...
  //...(the one in the column object in filterConfigs with the input dataIndex)...
  // ...IS empty (meaning the sorting was just reset),
  if (
    filterConfigs[dataIndex].sortState.direction == constants.emptySortDirection
  ) {
    // lower all priorities larger than the priority of the column with the input dataIndex by one...
    // ...and assign the value to our store.
    tempConfigs = lowerLargerPrioritiesByOne(
      tempConfigs,
      filterConfigs[dataIndex].sortState.priority,
    );

    // Now extract the current sortState...
    // ...from our store,
    const { sortState, ...rest } = tempConfigs[dataIndex]; // @TODO I think this can be changed to grab from filterConfigs since this value in store shouldn't have changed from the input filterConfigs
    // ..and assign empty sort directions and priority to the column object with the input dataIndex.
    tempConfigs[dataIndex] = {
      sortState: {
        direction: sortState.direction, // @TODO I think this can be changed to "constants.emptySortDirection" since its already empty
        priority: constants.emptySortPriority,
      },
      ...rest,
    };
  }
  // If the sort direction for this action...
  //...(the one in the column object in filterConfigs with the input dataIndex)...
  // ...IS NOT empty (meaning a new sort direction was just applied),
  else {
    // Extract the current sortState from our store,
    const { sortState, ...rest } = tempConfigs[dataIndex]; // @TODO I think this can be changed to grab from filterConfigs since this value in the store shouldn't have changed from the input filterConfigs

    // If the priority of the column object with the input dataIndex...
    // ...is NOT empty (meaning we're updating this from the other sorted state and need to make this the new last priority),
    if (sortState.priority != constants.emptySortPriority) {
      // lower all priorities larger than the priority of the column with the input dataIndex by one...
      // ...and assign the value to our store.
      tempConfigs = lowerLargerPrioritiesByOne(tempConfigs, sortState.priority);
    }

    // If this priority is not the largest priority (meaning the user clicked to update a column that was already last priority)...
    // OR if the priority is empty (meaning the user clicked to update a column that did not yet have a priority)...
    if (
      sortState.priority != getLargestPriority(filterConfigs) ||
      sortState.priority == constants.emptySortPriority
    ) {
      // Assign one higher priority than the greatest that exists...
      // ...(making this the new last priority)...
      // to the store at the column with the input dataIndex.
      tempConfigs[dataIndex] = {
        sortState: {
          direction: sortState.direction,
          priority: getLargestPriority(tempConfigs) + 1,
        },
        ...rest,
      };
    }
  }

  return tempConfigs;
};

const updateConfigs = (filterConfigs, dataIndex, newConfig) => {
  // Create a temporary configs store;
  var tempConfigs = filterConfigs;

  // Add the newConfig to the tempConfigs store;
  tempConfigs = replaceConfigByDataIndex(tempConfigs, dataIndex, newConfig);

  // If this column has sorting AND the column's sort direction has changed...
  // ...update the priorities of all other config when the config with this dataIndex changes.
  if (
    filterConfigs[dataIndex].sortDirections.length != 0 &&
    filterConfigs[dataIndex].sortState.direction !=
      newConfig.sortState.direction
  ) {
    // update the tempFilterConfigs store with revised priorities for the action occurred on this dataIndex
    tempConfigs = updatePriorities(tempConfigs, dataIndex);
  }

  return tempConfigs;
};

export default updateConfigs;
